<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="padding: 1%" v-if="!action">
          <h3 class="card-title">
            Falta verificar e-mail
            <span class="right badge badge-secondary">{{ total }}</span>
          </h3>
        </div>
        <div class="card-header" style="padding: 1%">
          <div class="card-title">
            <div class="card-tools">
              <form @submit.prevent>
                <div class="input-group input-group-sm" style="width: 150px">
                  <input
                    @keyup="buscarUsuarios"
                    type="text"
                    name="table_search"
                    v-model="filtro"
                    class="form-control float-right"
                    placeholder="Search"
                  />

                  <div class="input-group-append">
                    <button type="submit" class="btn btn-secondary" id="searchBtn" @click="buscarUsuarios(true)">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card-tools">
            <!-- PAGINAÇÃO  -->
            <ul class="pagination pagination-sm m-0 float-right">
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

              <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                <a
                  :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                  class="page-link"
                  href="#"
                  @click="selecionarPagina(pagina)"
                >
                  {{ pagina }}
                </a>
              </li>

              <li class="page-item">
                <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
              </li>
              <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
            </ul>
          </div>

          <div class="card-title">
            <div class="card-tools">
              <span style="margin-left: 15px">A tabela está ordenada por data de criação da conta (decrescente).</span>
            </div>
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body table-responsive p-0">
          <table class="table table-hover text-nowrap">
            <thead>
              <tr>
                <th>Seq</th>
                <th>ID</th>
                <th>Apelido</th>
                <th>Email</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(usuario, index) in users" :key="usuario.id">
                <td data-label="Seq">{{ index + 1 }}</td>
                <td data-label="Id">{{ usuario.id }}</td>
                <td data-label="Apelido">
                  <i class="fa-solid fa-circle" style="margin-right: 7px" :style="getStyleOnline(usuario)"></i>
                  <a style="text-transform: uppercase" href="#" @click="showEmptyUserError">{{ usuario.apelido }}</a>
                </td>

                <td data-label="Email">{{ usuario.email }}</td>

                <td data-label="Status">
                  <strong>Criado em:</strong>
                  {{ formatDate(usuario.created_at) }}
                </td>

                <td data-label="Ações">
                  <a
                    id="navbarDropdown"
                    class="nav-link"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    v-pre
                  >
                    <i class="fa-solid fa-bars" style="color: gray"></i>
                  </a>

                  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                    <div class="dropdown-divider"></div>
                    <a style="cursor: pointer" @click="reenviarEmail(usuario)" class="dropdown-item">
                      <i class="fa-solid fa-arrows-rotate"></i>
                      &nbsp;&nbsp; Reenviar email
                    </a>

                    <div class="dropdown-divider"></div>
                    <a style="cursor: pointer" @click="validarExcluirCadastro(usuario)" class="dropdown-item">
                      <i class="fa-solid fa-trash"></i>
                      &nbsp;&nbsp; Excluir
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer clearfix">
          <!-- TOTAIS  -->
          <div style="font-size: 13px" class="float-left" aria-live="polite">
            Exibindo do {{ inicio + 1 }} ao {{ inicio + users.length }}
            <p>Total {{ total }}</p>
          </div>

          <p class="float-left card-title" style="font-size: 12px; margin-right: 5px; margin-right: 5px; margin-left: 10px; color: black">
            Por página
          </p>

          <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
            <option :value="1">1</option>
            <option :value="2">2</option>
            <option :value="7">7</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
          </select>

          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["docs_tipo_usuario", "action"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading },

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      qtd_por_pagina: 25,
      pagina_atual: 1,
      inicio: 0,
      paginas: [],
      total: 0,
      users: [],
      filtro: "",
    };
  },

  mounted() {
    this.buscarUsuarios();

    if (this.action) {
      this.action("Falta verificar e-mail", this.total);
    }
  },

  methods: {
    validarExcluirCadastro(user) {
      console.log("V1");
      console.log(user);

      this.user_selecionado = user;

      let data = {
        id: user.id,
      };

      console.log("Validando");
      console.log(data);

      axios
        .post(`/admin/delete_user/validate`, data)
        .then((response) => {
          console.log("Resposta");
          console.log(response);

          if (response.data.success) {
            let html = "Deseja apagar o usuário com o e-mail " + user.email + " e com apelido " + user.apelido + " ? Essa ação é irreversível.";

            this.$swal
              .fire({
                title: "Confirmação",
                html: html,
                icon: "warning",
                padding: "1.5em",
                showCancelButton: true,
                cancelButtonText: "Cancelar",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, quero deletar!",
              })
              .then((result) => {
                if (result.value) {
                  this.isLoading = true;

                  let data = {
                    id: user.id,
                    pergunta: html,
                  };

                  axios
                    .post(`/admin/delete_user/delete`, data)
                    .then((response) => {
                      this.showSuccessMessage("Usuário deletado com sucesso!");
                      this.buscarUsuarios();
                    })
                    .catch((error) => {
                      this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                      console.log(error.response.data);
                    });
                }
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    confirmarDelete(usuario) {
      let html = "Deseja excluir o cadastro?";

      this.$swal
        .fire({
          title: "Atenção",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.deletar(usuario);
          }
        });
    },

    deletar(usuario) {
      this.isLoading = true;

      let data = {
        user_id: usuario.id,
      };

      console.log("DELETANDO");
      console.log(data);

      axios
        .post(`/admin/user/delete`, data)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.showSuccessMessageWithButtonAndReload("Sucesso!", "Cadastro deletado com sucesso");
          } else {
            this.showErrorMessageWithButton("Ops...", "Não é possível excluir esse usuário pois o mesmo já possui dados cadastrais.");
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao deletar usuário!");
          this.isLoading = false;
        });
    },

    showEmptyUserError() {
      this.showErrorMessageWithButton("Ops...", "Sem dados para exibir. O usuário não validou e-mail ainda.");
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = moment(new Date());
        let data = moment(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    reenviarEmail(user) {
      console.log("Reenviando " + user.email);

      this.isLoading = true;

      let data = {
        email: user.email,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/verify/email/send`, data)
        .then((response) => {
          console.log(response.data);
          this.showSuccessMessage("Email enviado!");
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getUrlDocumentos(user) {
      return "/admin/user/document/" + user.id;
    },

    show(doc_tipo_usuario) {
      this.doc_tipo_usuario_selecionado = doc_tipo_usuario;
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarUsuarios();
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarUsuarios();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarUsuarios();
      }
    },

    buscarUsuarios(pagina_inicial) {
      this.isLoading = true;

      if (pagina_inicial) {
        this.pagina_atual = 1;
        this.inicio = 0;
      }

      let data = {
        search: this.filtro,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/fluxo_de_cadastros/unverified-mail-table`, data)
        .then((response) => {
          console.log("Usuarios confirmando");
          console.log(response.data.usuarios);

          this.isLoading = false;

          this.users = response.data.usuarios;
          this.total = response.data.total;

          if (this.action) {
            this.action("Falta verificar e-mail", this.total);
          }

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>
